module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white-43b60f8021421437362ae666804b661b.png";